<template>
  <div class="DataSearch">
    <div class="DataSearch_box">
      <div class="filtrate">
        <div class="tit">{{$t('DataSerch.filter')}} &nbsp;&nbsp;&nbsp;</div>

        <span v-for="(item, i) in searchConditionCom">
          <span v-if="item" class="Condition">
            {{ item.name }}
            <i class="iconfont icon-guanbi" @click="deleteCondition(item)"></i
          ></span>
        </span>
      </div>
      <div class="condition_box">
        <div class="condition_box_tit">
          <i class="iconfont icon-xitong"></i>{{ $t("DataHub.Goal") }}:
        </div>
        <div
          class="condition_box_content"
          :class="[openMenuArr.indexOf(1) > -1 ? 'openMenu' : '']"
        >
          <div
            class="txt"
            v-for="(item, index) in goals"
            :key="index"
            :class="[searchCondition.goals == item ? 'all' : '']"
            @click="addCondition('goals', item)"
          >
            {{ item.name }}
          </div>
        </div>
        <!--  @click="allGoalsId()" -->
        <div class="more" @click="more(1)">
          <div class="text">{{$t('DataSerch.more')}}</div>
          <div :class="[openMenuArr.indexOf(1) > -1 ? 'rotate90' : 'rotate0']">
            <i class="iconfont icon-xiangxia1"></i>
          </div>
        </div>
      </div>
      <!-- 地球圈层 -->
      <div class="condition_box">
        <div class="condition_box_tit">
          <i class="iconfont icon-diqiu1"></i>{{$t('DataSerch.geosphere')}}：
        </div>
        <div
          class="condition_box_content" style="height:auto"
          :class="[openMenuArr.indexOf(2) > -1 ? 'openMenu' : '']"
        >
          <div
            class="txt"
            v-for="(item, index) in key"
            :key="index"
            :class="[searchCondition.keywords == item ? 'all' : '']"
            @click="addCondition('keywords', item)"
          >
            {{ item.name }}
          </div>
        </div>
        
      </div>
      <!-- 数据格式 -->
      <div class="condition_box">
        <div class="condition_box_tit">
          <i class="iconfont icon-weizhigeshi"></i>{{$t('DataSerch.format')}}：
        </div>
        <div
          class="condition_box_content"
          :class="[openMenuArr.indexOf(3) > -1 ? 'openMenu' : '']"
        >
          <div
            class="txt"
            v-for="(item, index) in data"
            :key="index"
            :class="[searchCondition.formats == item ? 'all' : '']"
            @click="addCondition('formats', item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 数据来源 -->
      <div class="condition_box">
        <div class="condition_box_tit">
          <i class="iconfont icon-laiyuandifenxi"></i>{{$t('DataSerch.source')}}：
        </div>
        <div
          class="condition_box_content"
          :class="[openMenuArr.indexOf(4) > -1 ? 'openMenu' : '']"
        >
          <!--   :class="[sourcsIdList == index ? 'all' : '']" -->
          <!--  v-model="sourcsIdList" -->
          <div class="txt" v-for="(item, index) in source" :key="index">
            <input
              :id="item.dataId"
              type="checkbox"
              :value="item.dataId"
              @change="getChecked(item)"
              v-model="dataIdsources"
            />
            <label :for="item.dataId" class="cursor">{{ item.name }}</label>
          </div>
        </div>
        <!--  @click="allGoalsId()" -->
        <div class="more" @click="more(4)">
          <div class="text">{{$t('DataSerch.more')}}</div>
          <div :class="[openMenuArr.indexOf(4) > -1 ? 'rotate90' : 'rotate0']">
            <i class="iconfont icon-xiangxia1"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { dataset } from "@/axios/datashare.js";
export default {
  mixins: [mapMixin],
  comments: {},
  data() {
    return {
      openMenuArr: [],
      searchCondition: {
        goals: null, //选中的goalsId
        formats: null,
        keywords: null,
        sources: [],
      },

      data: [],
      goals: [],
      key: [],
      source: [],
      dataIdsources: [],
    };
  },
  mounted() {
    this.getDataset();
  },
  computed: {
    searchConditionCom: function () {
      var arr = [];
      for (let key in this.searchCondition) {
        if (
          this.searchCondition[key] &&
          !Array.isArray(this.searchCondition[key])
        ) {
          arr.push(this.searchCondition[key]);
        }
        if (
          Array.isArray(this.searchCondition[key]) &&
          this.searchCondition[key].length > 0
        ) {
          this.searchCondition[key].forEach((element) => {
            arr.push(element);
          });
        }
      }
      return arr;
    },
  },
  watch: {
    sortVal(val) {
      bus.$emit("showDataList", this.searchCondition);
    },
    // language() {
    //   this.goalsIdList = null;
    //   this.dataIdList = null;
    //   this.keyIdList = null;
    //   this.sourcsIdList = null;
    //   this.getDataset();
    // },

    searchCondition: {
      deep: true, //true为进行深度监听,false为不进行深度监听
      handler(newVal) {
        bus.$emit("showDataList", newVal);
      },
    },
  },
  methods: {
    getChecked(obj) {
      if (this.searchCondition.sources.indexOf(obj) > -1) {
        var idx = this.searchCondition.sources.indexOf(obj);
        // 删除
        this.searchCondition.sources.splice(idx, 1);
      } else {
        this.searchCondition.sources.push(obj);
      }
    },
    more(idxVal) {
      var idx = this.openMenuArr.indexOf(idxVal);
      if (idx > -1) {
        this.openMenuArr.splice(idx, 1);
      } else {
        this.openMenuArr.push(idxVal);
      }
    },
    deleteCondition(item) {
      for (let key in this.searchCondition) {
        if (this.searchCondition[key]) {
          if (Array.isArray(this.searchCondition[key])) {
            this.searchCondition[key].forEach((obj, index) => {
              if (obj.dataId == item.dataId) {
                this.searchCondition[key].splice(index, 1);
                var idx = this.dataIdsources.indexOf(
                  this.searchCondition[key].dataId
                );
                this.dataIdsources.splice(idx, 1);
              }
            });
          } else {
            if (this.searchCondition[key].dataId == item.dataId) {
              this.searchCondition[key] = null;
            }
          }
        }
      }
    },
    addCondition(name, obj) {
      this.searchCondition[name] = obj;
    },

    async getDataset() {
      var res = await dataset();
      var data = res.data.data;
      var arr = ['goals','key','data','source']
      for (var i = 0; i < data.length; i++) {
        // console.log(this[arr[i]])
        this[arr[i]] = data[i].value;
        // if (data[i].key == "SDG目标" || data[i].key == "SDGs Goals") {
        //   this.goals = data[i].value;
        // }
        // if (data[i].key == "数据格式" || data[i].key == "Format") {
        //   this.data = data[i].value;
        // }
        // if (data[i].key == "关键字" || data[i].key == "Theme Keywords") {
        //   this.key = data[i].value;
        // }
        // if (data[i].key == "数据来源" || data[i].key == "Source") {
        //   this.source = data[i].value;
        // }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.openMenu {
  height: auto !important;
  overflow-y: auto !important;
  max-height: 200px;
}
.DataSearch {
  width: 1200px;
  margin: 0px auto;

  .DataSearch_box {
    padding: 0 20px 20px;
    background: #ffffff;
    border-bottom: 1px solid #eeeeee;
    z-index: 10;
    border-radius: 2px;
    .filtrate {
      width: 100%;
      // height: 50px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 36px;
      border-bottom: 1px solid #eee;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      .tit {
        font-weight: 600;
      }
      .Condition {
        padding: 4px 10px;
        background: #0a97d9;
        color: #fff;
        border-radius: 4px;
        margin-right: 6px;
      }
      i {
        margin-left: 10px;
        font-size: 12px;
        cursor: pointer;
        transition: 0.2s;
        &:hover {
          opacity: 0.7;
          transition: 0.2s;
        }
      }
    }
    .condition_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      // align-items: baseline;
      align-items: flex-start;
      height: 100%;
      padding: 10px 0;
      border-bottom: 1px solid #f7f9fc;
      .condition_box_tit {
        i {
          margin-right: 6px;
          color: #ccc;
        }
        width: 106px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        white-space: nowrap;
        
        font-size: 14px;
        color: #333;
        // font-weight: 600;
        height: 24px;
        padding-right: 6px;
        margin-right: 10px;
      }
      .condition_box_content {
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        height: 24px;
        overflow-y: hidden;
        align-items: flex-start;
        .txt {
          display: inline-block;
          margin-bottom: 4px;
          height: 24px;
          margin-right: 4px;
          font-size: 14px;
          padding: 2px 8px;
          display: flex;
          cursor: pointer;
          color: rgba(34, 34, 34, 1);
          &:hover {
            color: #0a97d9 !important;
            background: rgba(245, 245, 245, 1);
          }
          .cursor {
            cursor: pointer;
          }
        }
        .all {
          color: #0a97d9 !important;
          font-weight: 600;
          background: rgba(245, 245, 245, 1);
        }
      }
      .more {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        cursor: pointer;
        .text {
          margin-left: 6px;
          margin-right: 6px;
          color: #0078d4;
        }
        i {
          font-size: 14px;
        }
        .rotate90 {
          display: inline-block;
          transform: rotate(180deg);
          transition: 0.2s;
          color: #0078d4;
        }
        .rotate0 {
          display: inline-block;
          transform: rotate(0deg);
          transition: 0.2s;
          color: #0078d4;
        }
      }
    }
  }
}
</style>